module.exports = ".modal-title{text-align:center;font-weight:700}.modal-body{padding:3%}\n"